if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        var hasError = false;
        var bundle_key = $('#bundle_key').val();
        var bundle_name = $('#bundle_name').val();

        var formData = new FormData(this.form);
        var mainVariantId = parseInt(formData.get('id'), 10);
        var mainQuantity = parseInt(formData.get('quantity'), 10) || 1;

        // Collect properties from the form
        var mainProperties = {};
        for (var pair of formData.entries()) {
          if (pair[0].startsWith('properties[')) {
            var propKey = pair[0].replace('properties[', '').replace(']', '');
            mainProperties[propKey] = pair[1];
          }
        }

        var data = { items: [] };

        // Colour/yarn items
        $('.color-products-list .addon-item.active--item').each(function () {
          if ($(this).hasClass('item__disabled')) {
            var title = $(this).attr('data-title');
            $('.sold__out-msg span').text(title);
            $('.error-popup').removeClass('hidden');
            document.body.classList.add('popup-open');
            hasError = true;
            return false;
          }
          var id = $(this).attr('data-variant-id');
          var index = $(this).attr('data-index');
          var quantity = parseInt($(this).find('.custom-quantity-input').val());
          data.items.push({
            id: id,
            quantity: quantity,
            properties: { "Bundle": bundle_name, "_bundle_index": index, "_bundle_key": bundle_key }
          });
        });

        if (hasError) return;

        // Pattern/toggle items
        $(".toggle-input.active--item:not(.item__disabled):checked").each(function () {
          var $addonItem = $(this).closest(".addon-item");
          var $quantityInput = $addonItem.find(".custom-quantity-input");
          var id = parseInt($(this).val(), 10) || 0;
          var quantity = $quantityInput.length ? parseInt($quantityInput.val(), 10) || 1 : 1;
          data.items.push({
            id: id,
            quantity: quantity,
            properties: { "Bundle": bundle_name, "_bundle_key": bundle_key }
          });
        });

              // Accessories items
        $('.accessories__products .addon-item').each(function () {
          var qtyWrap = $(this).find('.accessories-qty-wrap')[0];
          if (!qtyWrap || qtyWrap.style.display === 'none') return;
          var id = parseInt($(this).attr('data-variant-id'), 10) || 0;
          if (!id) return;
          var quantity = parseInt($(this).find('.custom-quantity-input').val(), 10) || 1;
          data.items.push({
            id: id,
            quantity: quantity,
            properties: { "Bundle": bundle_name, "_bundle_key": bundle_key }
          });
        });

        // Guard: this product's yarn/colour options must be attached before checkout.
        // If none made it into data.items, block submission instead of letting the
        // kit's shell variant add on its own (see MS-255).
        if ($('.color-products-list .addon-item').length > 0 && $('.color-products-list .addon-item.active--item').length === 0) {
          this.handleErrorMessage('Please wait a moment for the kit contents to load, then try adding to cart again.');
          return;
        }

       

        // Main product
        data.items.push({
          id: mainVariantId,
          quantity: mainQuantity,
          properties: mainProperties
        });

        // Request sections render in the same call so ICU only fires once
        if (this.cart) {
          data.sections = this.cart.getSectionsToRender().map((section) => section.id);
          data.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const linesUpdateDeferred = this.createCartLinesUpdateEvent(mainVariantId, mainQuantity);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: mainVariantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
            linesUpdateDeferred?.reject(new Error(response.description || response.message));
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            this.resolveCartLinesUpdate(linesUpdateDeferred);
            window.location = window.routes.cart_url;
            return;
          }

          this.resolveCartLinesUpdate(linesUpdateDeferred);

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainVariantId,
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(response);
            });
          }
        })
        .catch((e) => {
          console.error(e);
          this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
          linesUpdateDeferred?.reject(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          this.generate_token(9);
          CartPerformance.measureFromEvent("add:user-action", evt);
        });
      }

      generate_token(length){
        var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
        var b = [];
        for (var i=0; i<length; i++) {
          var j = (Math.random() * (a.length-1)).toFixed(0);
          b[i] = a[j];
        }
        var key = b.join("");
        $('#bundle_key').val(key);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
